/* unplugin-vue-components disabled */import { render } from "./ActivityDetail.vue?vue&type=template&id=032d6633&scoped=true"
import script from "./ActivityDetail.vue?vue&type=script&lang=js"
export * from "./ActivityDetail.vue?vue&type=script&lang=js"

import "./ActivityDetail.vue?vue&type=style&index=0&id=032d6633&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-032d6633"]])

export default __exports__